/** @jsxImportSource @emotion/react */
import tw from "twin.macro";

import { css } from "@emotion/css";
import React, { FC, useEffect, useRef, useState } from "react";

import { MdDragHandle } from "react-icons/md";
import { ReactEventHandlers } from "react-use-gesture/dist/types";
import { Note } from "../state/data";
import {
  NEWEST_NOTE_ID,
  useNote,
  useNotesOperations,
} from "../state/state/store";
import ContentEditable from "react-contenteditable";
import { contextMenu } from "react-contexify";
import { useHover } from "react-use-gesture";
import { animated, useSpring } from "react-spring";

import {
  BiPaint,
  BiFastForwardCircle,
  BiExpand,
  BiExitFullscreen,
} from "react-icons/bi";
import { RiCheckboxBlankLine, RiCheckboxLine } from "react-icons/ri";

import { CirclePicker } from "react-color";
import { possibleBackgrounds } from "../state/data/init";
import { startOfTomorrow } from "date-fns";

import Popover from "@material-ui/core/Popover";

import {
  usePopupState,
  bindTrigger,
  bindPopover,
  PopupState,
  bindToggle,
} from "material-ui-popup-state/hooks";
import { getContrast, useOutsideAlerter } from "../utils";
import mergeRefs from "react-merge-refs";
import { Modal } from "@material-ui/core";
import { NoteRightClickMenu } from "../NoteRightClickMenu";

const computeBonusStyles = (n: Note) => {
  /* TODO: add this to vue compact only */
  // if (
  //   n.schedule.type === "EXACT" &&
  //   differenceInMinutes(n.schedule.end, n.schedule.start) < 14
  // ) {
  //   return {
  //     fontSize: "0.77em",
  //     padding: "0em",
  //     paddingRight: "0.6em",
  //     paddingLeft: "0.6em",
  //   };
  // }

  return {};
};

export const InnerNote: FC<{
  id: String;
  bind: (...args: any[]) => ReactEventHandlers;
  dragged?: boolean;
  controlledHeight: boolean;
  fullViewable?: boolean;
  parentPopupState?: PopupState;
}> = React.memo(
  ({
    id,
    bind,
    controlledHeight,
    dragged = false,
    fullViewable = true,
    parentPopupState = undefined,
  }) => {
    const notesOperations = useNotesOperations();
    const { note } = useNote(id)!;
    const ref = useRef<HTMLDivElement>(null);
    const [active, setActive] = useState(false);

    useEffect(() => {
      // console.log("buga", NEWEST_NOTE_ID);
      if (id === NEWEST_NOTE_ID) {
        setActive(true);
        ref.current?.focus();
      }
    }, [id]);

    const [controlSpring, setCSpring] = useSpring(() => ({
      width: "0em",
    }));
    const hoverBind = useHover((state) => {
      if (state.hovering) {
        setCSpring({ width: "8.5em" });
        setZindex(80);
      } else {
        setCSpring({ width: "0em" });
        setZindex(30);
      }
    });

    const [zindex, setZindex] = useState(30);
    const updateNote = (payload: Partial<Note>) => {
      notesOperations.updateNote({ ...note, ...payload });
    };
    // console.log("schedule is this", note.schedule);

    const bonusStyles = computeBonusStyles(note);

    const wrapperRef = useRef(null);

    useOutsideAlerter(wrapperRef, (event) => {
      setActive(false);
    });

    // useEffect(() => {
    //   function handleClickOutside(event) {
    //     // console.log("clicked outside");
    //     setActive(false);
    //   }
    //   document.addEventListener("mousedown", handleClickOutside);
    //   return () => {
    //     // Unbind the event listener on clean up
    //     document.removeEventListener("mousedown", handleClickOutside);
    //   };
    // }, [wrapperRef]);
    /* ${active &&
          css`
            --tw-ring-opacity: 1;
            --tw-ring-color: rgba(37, 99, 235, var(--tw-ring-opacity));
            --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
              var(--tw-ring-offset-width) var(--tw-ring-offset-color);
            --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
              calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
            box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
              var(--tw-shadow, 0 0 #0000);
          `} */
    return (
      <div
        className={css`
          background-color: ${note.background};
          color: ${getContrast(note.background)};
          z-index: ${zindex};
          height: 100%;
          width: 100%;
          // border: 1px solid rgba(0, 0, 0, 0.32);
          // box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px,
          //   rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
          border-radius: 8px;
          overflow: auto;
          position: relative;

          * {
            user-select: auto;
          }
          ${active &&
          css`
            --tw-ring-opacity: 1;
            --tw-ring-color: rgba(37, 99, 235, var(--tw-ring-opacity));
            --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
              var(--tw-ring-offset-width) var(--tw-ring-offset-color);
            --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
              calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
            box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
              var(--tw-shadow, 0 0 #0000);
          `}
        `}
        style={{
          textDecoration: note.completed ? "line-through" : "inherit",
          maxHeight: controlledHeight || dragged ? "inherit" : "4.4em",
        }}
        onContextMenu={(e) => {
          console.log("on context menu...");
          e.preventDefault();
          contextMenu.show({
            id: "note_right_click_menu",
            event: e,
            props: { noteId: note.id },
          });
        }}
        onKeyDown={(e) => {
          setCSpring({ width: "0rem" });
          // enter: setActive(false)
          if (e.key === "Enter") {
            if (e.shiftKey) {
            } else {
              setActive(false);
              e.preventDefault();
              if (document !== null && document.activeElement !== null) {
                //@ts-ignore
                document.activeElement.blur();
              }
            }
          }
          if (e.key === "Backspace" && note.title.length === 0) {
            notesOperations.removeNote(id);
          }
        }}
        onClick={(e) => {
          setActive(true);
        }}
        ref={mergeRefs([wrapperRef])}
      >
        <animated.div
          tw="h-full max-h-12 flex absolute z-10 right-0 overflow-hidden"
          style={{
            width: controlSpring.width,
            //@ts-ignore
            backgroundColor: note.background,
          }}
          {...hoverBind()}
        >
          <QuickActionMenu
            note={note}
            updateNote={updateNote}
            fullViewable={fullViewable}
            bind={bind}
            parentPopupState={parentPopupState}
          />
        </animated.div>
        <ContentEditable
          className={css`
            padding: 0.5em;
            padding-left: 0.8em;
            padding-right: 0.8em;
            /* font-weight: 400; */
            font-size: 0.85em;
            margin: auto 0 auto 0;
            height: 100%;
            width: 100%;
            user-select: text;
            text-align: justify;
            outline: none;
          `}
          style={{
            // opacity: note.completed ? 0.65 : 1,
            textDecoration: note.completed ? "line-through" : "inherit",
            cursor: active ? "text" : "grab",
            ...bonusStyles,
          }}
          {...hoverBind()}
          html={note.title} // innerHTML of the editable div
          // disabled={!active} // use true to disable edition
          onChange={(e) => {
            console.log("change");
            notesOperations.updateNoteById(note.id, (n: Note) => ({
              ...n,
              title: e.target.value,
            }));
          }}
          innerRef={ref}
          {...(active ? {} : { ...bind() })}
          data-clarity-mask="True"
        />
      </div>
    );
  }
);

function QuickActionMenu({
  note,
  updateNote,
  fullViewable,
  bind,
  parentPopupState,
}) {
  const colorPickerState = usePopupState({
    variant: "popover",
    popupId: "colorpicker-" + note.id,
  });
  const fullViewState = usePopupState({
    variant: "popover",
    popupId: "fullview-" + note.id,
  });

  return (
    <div
      tw="h-full px-2 flex place-items-end rounded-lg"
      style={{ fontSize: "0.9em", width: "9.5em" }}
    >
      {fullViewable && (
        <>
          {" "}
          <div
            tw="w-8 h-full flex cursor-pointer"
            {...bindTrigger(fullViewState)}
            title="Expand"
          >
            <BiExpand tw="m-auto" />
          </div>
          <Modal
            {...bindPopover(fullViewState)}
            tw="m-48 mx-auto max-w-5xl"
            onContextMenu={(e) => {
              console.log("on context menu...");
              e.preventDefault();
              contextMenu.show({
                id: "note_right_click_menu",
                event: e,
                props: { noteId: note.id },
              });
            }}
          >
            <>
              <InnerNote
                id={note.id}
                bind={() => ({})}
                fullViewable={false}
                parentPopupState={fullViewState}
                controlledHeight={true}
              />
              <NoteRightClickMenu />
            </>
          </Modal>
        </>
      )}
      <div
        tw="w-8 h-full flex cursor-pointer"
        onClick={() =>
          updateNote({
            completed: !note.completed,
          })
        }
        title="Complete/Uncomplete"
      >
        {note.completed ? (
          <RiCheckboxLine tw="m-auto" />
        ) : (
          <RiCheckboxBlankLine tw="m-auto" />
        )}
      </div>
      <div
        tw="w-8 h-full flex cursor-pointer"
        title="Change color"
        {...bindTrigger(colorPickerState)}
      >
        <BiPaint tw="m-auto" />
      </div>
      <Popover
        {...bindPopover(colorPickerState)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <div
          tw="bg-white m-2"
          style={{
            height: "245px",
          }}
        >
          <CirclePicker
            color={note.background}
            colors={possibleBackgrounds}
            onChangeComplete={(color) => {
              updateNote({
                background: color.hex,
              });
              colorPickerState.close();
            }}
          />
        </div>
      </Popover>
      {/* <div
        tw="w-8 h-full flex cursor-pointer"
        onClick={() => removeNote(note.id)}
        title="Delete"
      >
        <RiDeleteBin6Line tw="m-auto" />
      </div> */}
      <div
        tw="w-8 h-full flex cursor-pointer"
        onClick={() =>
          updateNote({
            schedule: {
              type: "DAY",
              day: startOfTomorrow(),
            },
          })
        }
        title="Do tomorrow"
      >
        <BiFastForwardCircle tw="m-auto" />
      </div>
      {fullViewable && (
        <div tw="w-8 h-full flex cursor-pointer ml-2">
          <MdDragHandle tw="m-auto" style={{ fontSize: "1.2em" }} {...bind()} />
        </div>
      )}
      {!fullViewable && (
        <div
          tw="w-8 h-full flex cursor-pointer"
          title="Expand"
          {...bindToggle(parentPopupState)}
        >
          <BiExitFullscreen tw="m-auto" />
        </div>
      )}
    </div>
  );
}
